// extracted by mini-css-extract-plugin
export default {"footerContainer":"PaginationButton_footerContainer__p6Ef9","loadMoreButton":"PaginationButton_loadMoreButton__pSxnH"};